@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.mpay_qr.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.mpay_qr.generated.resources/"

internal val Res.string.feature_mpay_qr_account_ids: StringResource by lazy {
      StringResource("string:feature_mpay_qr_account_ids", "feature_mpay_qr_account_ids", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 51),
      ))
    }

internal val Res.string.feature_mpay_qr_account_number: StringResource by lazy {
      StringResource("string:feature_mpay_qr_account_number", "feature_mpay_qr_account_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62, 58),
      ))
    }

internal val Res.string.feature_mpay_qr_copied: StringResource by lazy {
      StringResource("string:feature_mpay_qr_copied", "feature_mpay_qr_copied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121, 58),
      ))
    }

internal val Res.string.feature_mpay_qr_copy: StringResource by lazy {
      StringResource("string:feature_mpay_qr_copy", "feature_mpay_qr_copy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 180, 36),
      ))
    }

internal val Res.string.feature_mpay_qr_download_qr: StringResource by lazy {
      StringResource("string:feature_mpay_qr_download_qr", "feature_mpay_qr_download_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217, 47),
      ))
    }

internal val Res.string.feature_mpay_qr_downloaded: StringResource by lazy {
      StringResource("string:feature_mpay_qr_downloaded", "feature_mpay_qr_downloaded", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 265, 58),
      ))
    }

internal val Res.string.feature_mpay_qr_external_id: StringResource by lazy {
      StringResource("string:feature_mpay_qr_external_id", "feature_mpay_qr_external_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324, 51),
      ))
    }

internal val Res.string.feature_mpay_qr_failed_to_generate: StringResource by lazy {
      StringResource("string:feature_mpay_qr_failed_to_generate", "feature_mpay_qr_failed_to_generate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 376, 78),
      ))
    }

internal val Res.string.feature_mpay_qr_go_back: StringResource by lazy {
      StringResource("string:feature_mpay_qr_go_back", "feature_mpay_qr_go_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 455, 43),
      ))
    }

internal val Res.string.feature_mpay_qr_inter_bank: StringResource by lazy {
      StringResource("string:feature_mpay_qr_inter_bank", "feature_mpay_qr_inter_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 499, 54),
      ))
    }

internal val Res.string.feature_mpay_qr_intra_bank: StringResource by lazy {
      StringResource("string:feature_mpay_qr_intra_bank", "feature_mpay_qr_intra_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 554, 54),
      ))
    }

internal val Res.string.feature_mpay_qr_no_currency_found: StringResource by lazy {
      StringResource("string:feature_mpay_qr_no_currency_found", "feature_mpay_qr_no_currency_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 609, 65),
      ))
    }

internal val Res.string.feature_mpay_qr_no_default_account: StringResource by lazy {
      StringResource("string:feature_mpay_qr_no_default_account", "feature_mpay_qr_no_default_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 675, 122),
      ))
    }

internal val Res.string.feature_mpay_qr_primary: StringResource by lazy {
      StringResource("string:feature_mpay_qr_primary", "feature_mpay_qr_primary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 798, 43),
      ))
    }

internal val Res.string.feature_mpay_qr_receive_money: StringResource by lazy {
      StringResource("string:feature_mpay_qr_receive_money", "feature_mpay_qr_receive_money", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 842, 57),
      ))
    }

internal val Res.string.feature_mpay_qr_scan_instruction: StringResource by lazy {
      StringResource("string:feature_mpay_qr_scan_instruction", "feature_mpay_qr_scan_instruction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 900, 76),
      ))
    }

internal val Res.string.feature_mpay_qr_scan_to_pay: StringResource by lazy {
      StringResource("string:feature_mpay_qr_scan_to_pay", "feature_mpay_qr_scan_to_pay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 977, 83),
      ))
    }

internal val Res.string.feature_mpay_qr_share: StringResource by lazy {
      StringResource("string:feature_mpay_qr_share", "feature_mpay_qr_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1102, 37),
      ))
    }

internal val Res.string.feature_mpay_qr_share_qr: StringResource by lazy {
      StringResource("string:feature_mpay_qr_share_qr", "feature_mpay_qr_share_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1061, 40),
      ))
    }

internal val Res.string.feature_mpay_qr_unable_to_generate: StringResource by lazy {
      StringResource("string:feature_mpay_qr_unable_to_generate", "feature_mpay_qr_unable_to_generate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1140, 78),
      ))
    }

internal val Res.string.feature_mpay_qr_unknown: StringResource by lazy {
      StringResource("string:feature_mpay_qr_unknown", "feature_mpay_qr_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1219, 43),
      ))
    }

internal val Res.string.feature_request_money_amount: StringResource by lazy {
      StringResource("string:feature_request_money_amount", "feature_request_money_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1263, 44),
      ))
    }

internal val Res.string.feature_request_money_cancel: StringResource by lazy {
      StringResource("string:feature_request_money_cancel", "feature_request_money_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1308, 44),
      ))
    }

internal val Res.string.feature_request_money_confirm: StringResource by lazy {
      StringResource("string:feature_request_money_confirm", "feature_request_money_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1353, 49),
      ))
    }

internal val Res.string.feature_request_money_currency: StringResource by lazy {
      StringResource("string:feature_request_money_currency", "feature_request_money_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1403, 54),
      ))
    }

internal val Res.string.feature_request_money_enter_currency: StringResource by lazy {
      StringResource("string:feature_request_money_enter_currency", "feature_request_money_enter_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1458, 64),
      ))
    }

internal val Res.string.feature_request_money_enter_valid_amount: StringResource by lazy {
      StringResource("string:feature_request_money_enter_valid_amount", "feature_request_money_enter_valid_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1523, 84),
      ))
    }

internal val Res.string.feature_request_money_error_oops: StringResource by lazy {
      StringResource("string:feature_request_money_error_oops", "feature_request_money_error_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1608, 48),
      ))
    }

internal val Res.string.feature_request_money_loading: StringResource by lazy {
      StringResource("string:feature_request_money_loading", "feature_request_money_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1657, 49),
      ))
    }

internal val Res.string.feature_request_money_nothing_to_notify: StringResource by lazy {
      StringResource("string:feature_request_money_nothing_to_notify", "feature_request_money_nothing_to_notify", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1707, 71),
      ))
    }

internal val Res.string.feature_request_money_qr_code_details: StringResource by lazy {
      StringResource("string:feature_request_money_qr_code_details", "feature_request_money_qr_code_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1779, 65),
      ))
    }

internal val Res.string.feature_request_money_request: StringResource by lazy {
      StringResource("string:feature_request_money_request", "feature_request_money_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1845, 49),
      ))
    }

internal val Res.string.feature_request_money_set_amount: StringResource by lazy {
      StringResource("string:feature_request_money_set_amount", "feature_request_money_set_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1895, 56),
      ))
    }

internal val Res.string.feature_request_money_there_is_nothing_to_show: StringResource by lazy {
      StringResource("string:feature_request_money_there_is_nothing_to_show", "feature_request_money_there_is_nothing_to_show", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1952, 86),
      ))
    }

internal val Res.string.feature_request_money_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_request_money_unexpected_error_subtitle", "feature_request_money_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2039, 119),
      ))
    }

internal val Res.string.feature_request_money_usd: StringResource by lazy {
      StringResource("string:feature_request_money_usd", "feature_request_money_usd", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2159, 37),
      ))
    }

internal val Res.string.feature_request_money_vpa: StringResource by lazy {
      StringResource("string:feature_request_money_vpa", "feature_request_money_vpa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2197, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_mpay_qr_account_ids", Res.string.feature_mpay_qr_account_ids)
  map.put("feature_mpay_qr_account_number", Res.string.feature_mpay_qr_account_number)
  map.put("feature_mpay_qr_copied", Res.string.feature_mpay_qr_copied)
  map.put("feature_mpay_qr_copy", Res.string.feature_mpay_qr_copy)
  map.put("feature_mpay_qr_download_qr", Res.string.feature_mpay_qr_download_qr)
  map.put("feature_mpay_qr_downloaded", Res.string.feature_mpay_qr_downloaded)
  map.put("feature_mpay_qr_external_id", Res.string.feature_mpay_qr_external_id)
  map.put("feature_mpay_qr_failed_to_generate", Res.string.feature_mpay_qr_failed_to_generate)
  map.put("feature_mpay_qr_go_back", Res.string.feature_mpay_qr_go_back)
  map.put("feature_mpay_qr_inter_bank", Res.string.feature_mpay_qr_inter_bank)
  map.put("feature_mpay_qr_intra_bank", Res.string.feature_mpay_qr_intra_bank)
  map.put("feature_mpay_qr_no_currency_found", Res.string.feature_mpay_qr_no_currency_found)
  map.put("feature_mpay_qr_no_default_account", Res.string.feature_mpay_qr_no_default_account)
  map.put("feature_mpay_qr_primary", Res.string.feature_mpay_qr_primary)
  map.put("feature_mpay_qr_receive_money", Res.string.feature_mpay_qr_receive_money)
  map.put("feature_mpay_qr_scan_instruction", Res.string.feature_mpay_qr_scan_instruction)
  map.put("feature_mpay_qr_scan_to_pay", Res.string.feature_mpay_qr_scan_to_pay)
  map.put("feature_mpay_qr_share", Res.string.feature_mpay_qr_share)
  map.put("feature_mpay_qr_share_qr", Res.string.feature_mpay_qr_share_qr)
  map.put("feature_mpay_qr_unable_to_generate", Res.string.feature_mpay_qr_unable_to_generate)
  map.put("feature_mpay_qr_unknown", Res.string.feature_mpay_qr_unknown)
  map.put("feature_request_money_amount", Res.string.feature_request_money_amount)
  map.put("feature_request_money_cancel", Res.string.feature_request_money_cancel)
  map.put("feature_request_money_confirm", Res.string.feature_request_money_confirm)
  map.put("feature_request_money_currency", Res.string.feature_request_money_currency)
  map.put("feature_request_money_enter_currency", Res.string.feature_request_money_enter_currency)
  map.put("feature_request_money_enter_valid_amount", Res.string.feature_request_money_enter_valid_amount)
  map.put("feature_request_money_error_oops", Res.string.feature_request_money_error_oops)
  map.put("feature_request_money_loading", Res.string.feature_request_money_loading)
  map.put("feature_request_money_nothing_to_notify", Res.string.feature_request_money_nothing_to_notify)
  map.put("feature_request_money_qr_code_details", Res.string.feature_request_money_qr_code_details)
  map.put("feature_request_money_request", Res.string.feature_request_money_request)
  map.put("feature_request_money_set_amount", Res.string.feature_request_money_set_amount)
  map.put("feature_request_money_there_is_nothing_to_show", Res.string.feature_request_money_there_is_nothing_to_show)
  map.put("feature_request_money_unexpected_error_subtitle", Res.string.feature_request_money_unexpected_error_subtitle)
  map.put("feature_request_money_usd", Res.string.feature_request_money_usd)
  map.put("feature_request_money_vpa", Res.string.feature_request_money_vpa)
}
